let initialState = {
	isModalVisible: false,
	brandValue: null,
	workspaceFormData: {
		formStatus: true,
		estimateStatus: false,
		extend: false,
		data: { workspaceName: null, brands: null, duration: null },
	},
	reportEstimate: null,
	workspace: false,
	userReports: null,
	reportTimeLoader: false,
	createReport: null,
	reportStatus: null,
	reportStatusLoader: 1,
	reportDelete: null,
	deleteReportModal: false,
	tableRowDel: null,
	mentionQuotaError: false,
	mentionQuotaValue: null,
	reportsLoader: false,
};

const CreateWorkspace = (state = initialState, action) => {
	switch (action.type) {
		case "SET_CREATEWORKSPACE_VISIBLE":
			return {
				...state,
				isModalVisible: action.payload,
			};
		case "SET_CREATEWORKSPACE_VALUE":
			return {
				...state,
				createWorkSpace: action.payload,
			};
		case "SET_WORKSPACE_BRAND_VALUE":
			return {
				...state,
				brandValue: action.payload,
			};
		case "SET_WORKSPACE_FORM_DATA":
			return {
				...state,
				workspaceFormData: action.payload,
			};
		case "SET_REPORT_TIME":
			return {
				...state,
				reportEstimate: action.payload,
			};
		case "SET_WORKSPACE":
			return {
				...state,
				workspace: action.payload,
			};
		case "SET_USER_REPORTS":
			return {
				...state,
				userReports: action.payload,
			};
		case "SET_REPORT_TIME_LOADER":
			return {
				...state,
				reportTimeLoader: action.payload,
			};
		case "SET_CREATE_REPORT":
			return {
				...state,
				createReport: action.payload,
			};
		case "SET_REPORT_STATUS_POLL":
			return {
				...state,
				reportStatus: action.payload,
			};
		case "SET_REPORT_DELETE":
			return {
				...state,
				reportDelete: action.payload,
			};
		case "SET_REPORT_STATUS_LOADER":
			return {
				...state,
				reportStatusLoader: action.payload,
			};
		case "SET_DELETE_REPORT_MODAL":
			return {
				...state,
				deleteReportModal: action.payload,
			};
		case "SET_TABLE_ROW_DELETE":
			return {
				...state,
				tableRowDel: action.payload,
			};
		case "MENTION_QUOTA_ERROR":
			return {
				...state,
				mentionQuotaError: action.payload,
			};
		case "SET_MENTION_QUOTA":
			return {
				...state,
				mentionQuotaValue: action.payload,
			};
		case "SET_REPORTS_LOADER":
			return {
				...state,
				reportsLoader: action.payload,
			};
		default:
			return state;
	}
};

export default CreateWorkspace;
